import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  text: PropTypes.string.isRequired
};

function QuestionText(props) {

    return (
        <div className="col-10 offset-1 my-sm-3 md-question-heading d-flex">
            <h1 className="fw-600 text-center m-auto md-dynamic-font-size">{ props.text }</h1>
        </div>
    );
  
}

QuestionText.propTypes = propTypes;

export default QuestionText;